/**
 * @module Address-Finder Exports
 */
import { setup, go, controllers } from "./setup";
import { watch } from "./watch";
import { Controller, defaults } from "./controller";
/**
 * Namespace that exports Address Finder methods and classes
 */
export const AddressFinder = {
    setup,
    controllers,
    Controller,
    defaults,
    watch,
    go,
};
